// src/lib/http.ts

// =======================================
// APIベースURL設定（/api/api を絶対に作らない）
// =======================================

// env から取得（Vite / CRA 両対応）
const RAW_BASE =
  (
    process.env.REACT_APP_API_BASE ||
    process.env.REACT_APP_API_BASE_URL ||
    ""
  ).replace(/\/+$/, "");

// API_BASE を一意に決定
export const API_BASE = (() => {
  // env が無い場合
  if (!RAW_BASE) {
    // ブラウザ（本番）は同一オリジン + /api
    if (typeof window !== "undefined") {
      return "/api";
    }
    // Node（ローカル）
    return "http://localhost:4000/api";
  }

  // 既に /api を含んでいる場合はそのまま
  if (RAW_BASE.endsWith("/api")) {
    return RAW_BASE;
  }

  // 含んでいなければ付与
  return `${RAW_BASE}/api`;
})();

// 起動時にベースURL確認（デバッグ用）
if (typeof window !== "undefined") {
  // eslint-disable-next-line no-console
  console.log("[OKM] API_BASE =", API_BASE);
}

// =======================================
// HTTP共通ラッパー
// =======================================
export type Method = "GET" | "POST" | "PUT" | "PATCH" | "DELETE";

/**
 * 共通Fetchラッパー
 * path: /auth/me のように指定（API_BASE に /api 含まれる）
 */
async function request<T>(
  path: string,
  method: Method,
  body?: unknown
): Promise<T> {
  const cleanPath = path.startsWith("/") ? path : `/${path}`;
  const url = `${API_BASE}${cleanPath}`;

  const res = await fetch(url, {
    method,
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: body !== undefined ? JSON.stringify(body) : undefined,
  });

  if (!res.ok) {
    const text = await res.text().catch(() => "");
    // eslint-disable-next-line no-console
    console.error("[OKM HTTP ERROR]", method, url, res.status, text);
    throw new Error(`${res.status} ${res.statusText}`);
  }

  return res.json() as Promise<T>;
}

// =======================================
// 外部公開APIメソッド
// =======================================
export const http = {
  get:   <T>(p: string) => request<T>(p, "GET"),
  post:  <T>(p: string, b?: unknown) => request<T>(p, "POST", b),
  put:   <T>(p: string, b?: unknown) => request<T>(p, "PUT", b),
  patch: <T>(p: string, b?: unknown) => request<T>(p, "PATCH", b),
  del:   <T>(p: string) => request<T>(p, "DELETE"),
};
